import styled from 'styled-components';

export const ListWrapper = styled.div`
    margin: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
`;

export const NotFound = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
